<div class=" !{{customClass}}"
[ngClass]="{'sml-option-control-grid': !combinedViewWithButton, 
'sml-option-combined-view': combinedViewWithButton}">
    <div class="sml-option-control-item" *ngFor="let key of getEnumKeys(); let i = index" [ngClass]="{'tw-min-h-[82px]': customInputHeight,
    }">
      <label [for]="groupIdentifier + '-input-' + i" class="sml-option-control-label tw-w-full tw-flex tw-items-center tw-p-3 tw-border tw-border-solid tw-cursor-pointer {{adjustHeight}}"
      [ngClass]="{
        'tw-border-primary-200 tw-bg-primary-100 tw-text-dark-grey': isChecked(options[key]),
        'tw-border-mercury-200 tw-bg-white tw-text-grey-750': !isChecked(options[key]),
        'tw-h-full tw-items-baseline': adjustHeight,
        '!tw-bg-[#F8F8F8] !tw-cursor-not-allowed !tw-text-[#828485]': getDisabledOption(options[key]),
        'tw-rounded-tr-lg tw-rounded-br-lg': i % 2 !== 0,  
        'tw-rounded-tl-lg tw-rounded-bl-lg': i % 2 === 0,
        '!tw-cursor-not-allowed !tw-pointer-events-none': notAllowedPointer
      }">
        <div class="tw-flex tw-items-center tw-gap-2 tw-overflow-hidden">
            <i-icon *ngIf="iconName.length" [name]="iconName[i % iconName.length].name"  
             [ngClass]="{
                'tw-text-primary-700' :isChecked(options[key]),
                '!tw-h-[16px] !tw-w-[16px]': interactiveTourIcon,
                '!tw-w-[22px] !tw-h-[22px]' : !interactiveTourIcon
            }"></i-icon>
            <div class="tw-flex"
            [ngClass]="{'tw-flex-col': !combinedViewWithButton,
              'tw-flex-row':combinedViewWithButton
            }">
              @if(combinedViewWithButton){
                <input [type]="inputType" [id]="groupIdentifier + '-input-' + i" [name]="name" [value]="options[key]" [checked]="isChecked(options[key])"
                (change)="onInputChange(options[key])"
                [class]="'sml-option-control tw-border tw-border-solid tw-mr-[7.5px] tw-relative tw-cursor-pointer tw-flex-grow-0 tw-flex-shrink-0  ' + (inputType === 'checkbox' ? 'tw-w-5 tw-h-5 tw-basis-5 tw-rounded !tw-mr-2.5' : 'tw-w-4 tw-h-4 tw-basis-4 tw-rounded-full tw-appearance-none') "
                [ngClass]=" isChecked(options[key]) ? 'tw-border-primary-700 after:tw-scale-100' : 'tw-border-mercury-200 tw-bg-surface-100 after:tw-scale-0' "
                [disabled]="getDisabledOption(options[key])" />
              }
              @else{
                <input [type]="inputType" class="tw-absolute tw-opacity-0 tw-pointer-events-none" [id]="groupIdentifier + '-input-' + i" [name]="name" [value]="options[key]" [checked]="isChecked(options[key])"
              (change)="onInputChange(options[key])"
              [class]="'sml-option-control tw-border tw-border-solid tw-mr-[7.5px]' + (inputType === 'checkbox' ? 'tw-w-5 tw-h-5 tw-basis-5 tw-rounded !tw-mr-2.5' : 'tw-w-4 tw-h-4 tw-basis-4 tw-rounded-full tw-appearance-none') "
              [ngClass]=" isChecked(options[key]) ? 'tw-border-primary-700 after:tw-scale-100' : 'tw-border-mercury-200 tw-bg-surface-100 after:tw-scale-0' "
              [disabled]="getDisabledOption(options[key])" />
              }
           
             
            <div class="sml-option-control-name tw-font-medium tw-text-sm" id="option-text-{{ i }}">
              {{ key }}
            </div>
            <div *ngIf="showSubheadings && subheadings[key]" class="sml-option-control-text tw-text-[12px] tw-leading-4 tw-font-medium tw-text-mercury-600"
           >
            {{ subheadings[key] }}
          </div>
          </div>
          
        </div>
      </label>
    </div>
  </div>
  